import _ from 'lodash'
import api from './interceptor'
import apiFulfillment from './interceptorFulfillment'
import apiEW from './interceptorEW'
import { EWOrderTypeFlag } from '../util/order/staticConfig'

// 获取订单列表数据
export const getOrderList = params => {
  // 旧订单接口 api.get('/order/list', { params })
  // 新聚合接口(新增延保订单)
  return apiEW.get('/occ/order/as/aggregator/client/v1/mall/orders/list', { params })
}
// 获取订单数量统计
export const getStatisOrder = params => {
  return api.get('/order/statisOrder', { params })
}
// 获取订单详情信息
export const getOrderDetail = params => {
  const isEwOrder = params.orderTypeFlag == EWOrderTypeFlag
  return isEwOrder ? apiEW.get(`/occ/order/as/ew/service/v1/mall/orders/${params.id}`) : api.get('/order/get', { params })
}
// 立即支付
export const payOrder = params => {
  return api.get('/loyalty/plan/getPlanDetails', { params })
}
// 取消订单
export const cancelOrder = params => {
  const isEwOrder = params.orderTypeFlag === EWOrderTypeFlag
  return isEwOrder ? apiEW.post('/occ/order/as/ew/client/v1/order/deal', { ...params, operateType: 'CANCEL' }) : api.post('/order/dealOrder', params)
}
// 申请退款
export const applyRefund = params => {
  const { orderTypeFlag } = params
  return orderTypeFlag === EWOrderTypeFlag
    ? apiEW.post('/occ/order/as/ew/client/v1/order/deal', { ...params, operateType: 'REFUND' })
    : api.post('/order/dealOrder', params)
}
// 撤销退款
export const cancelRefund = params => {
  return api.post('/order/dealOrder', params)
}
// 确认完成
export const sureFinished = params => {
  const { orderTypeFlag } = params
  return orderTypeFlag === EWOrderTypeFlag
    ? apiEW.post('/occ/order/as/ew/client/v1/order/deal', { ...params, operateType: 'ACTIVATION' })
    : api.post('/order/dealOrder', params)
}
// 订单删除接口
export const deleteOrder = params => {
  const { orderTypeFlag, orderId, orderNo } = params
  return orderTypeFlag === EWOrderTypeFlag ? apiEW.delete(`/occ/order/as/ew/client/v1/mobile/order/${orderNo}`) : api.post('/order/delete', { orderId })
}

// 提交订单
export const addOrder = params => {
  return api.post('/order/add', params)
}

// 订单结算
export const settleOrder = params => {
  return api.post('/order/settleOrder', params)
}

// 获取致友计划使用消费记录
export const getLoyaltyPlanUseCouponList = params => {
  return api.get('/order/loyaltyPlanUseCouponList', { params })
}

// 服务订单操作
export const dealServiceOrder = params => {
  return api.post('/order/dealServiceOrder', params)
}

// 服务订单退款操作
export const dealServiceOrderRefund = params => {
  return api.post('/order/dealServiceOrderRefund', params)
}

//获取支付链接
export const getPayUrl = params => {
  const { orderTypeFlag } = params
  return orderTypeFlag === EWOrderTypeFlag
    ? apiEW.get(`/occ/order/as/ew/client/v1/mobile/order/pay-url/${params.orderNo}/${params.payMethod}`)
    : api.get(`/pay/orderPay/getPayUrl/${params.orderNo}/${params.payMethod}`)
}

// 服务合约订单可用经销商
export const getContractApplyDealerList = params => {
  // return apiFulfillment.post('/order/dealer/applyDealerList', params)
  return apiFulfillment.get('/malllist/orderDealerList', { params })
}

// 延保订单可用经销商
export const getEwContractApplyDealerList = params => {
  return apiEW.post('/occ/order/as/ew/client/v1/mobile/order/dealers', { ...params })
}

// 延保订单可用经销商
export const getEwCouponApplyDealerList = params => {
  return apiEW.get(`/occ/order/as/ew/client/v1/mobile/order/coupon/${params.couponId}/available-dealers`, {
    params: _.pick(params, ['cityName', 'keyword', 'latitude', 'longitude'])
  })
}

// 服务合约订单查询组合优惠
export const getDiscountGroupOrdersByGroupId = params => {
  return api.get('/order/getDiscountGroupOrders', { params })
}
